<template>
  <div>
    <span>{{ message.message }}</span>

    <div class="categories">
      <div
        class="item"
        :class="{ 'selected-item': message.selectedOption === PredefinedOptionType.POSITIVE_RESOLUTION }"
        @click="buildEvent(PredefinedOptionType.POSITIVE_RESOLUTION)"
      >
        <span class="icon-left"> <LikeIcon /> {{ t('global.yes') }} </span>
      </div>

      <div
        class="item"
        :class="{ 'selected-item': message.selectedOption === PredefinedOptionType.CONNECT_TO_SUPPORT }"
        @click="buildEvent(PredefinedOptionType.CONNECT_TO_SUPPORT)"
      >
        <span class="icon-left"> <CustomerSupportIcon /> {{ $t('chat.sys.navigation.contact_support') }} </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { PredefinedOptionType, PredefinedPreSupportOptions, SystemEvent } from '@/common/bot/enum';
import { BaseSystemMessage, PreSupportSelectionEvent } from '@/common/bot/types';
import CustomerSupportIcon from '@/components/icons/CustomerSupportIcon.vue';
import FaAngleRight from '@/components/icons/FaAngleRight.vue';
import LikeIcon from '@/components/icons/LikeIcon.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    FaAngleRight,
    CustomerSupportIcon,
    LikeIcon,
  },
})
export default class PreSupportConfirmation extends Vue {
  @Prop({ default: () => ({}) }) readonly message!: BaseSystemMessage;

  readonly PredefinedOptionType = PredefinedOptionType;

  buildEvent(selected: PredefinedPreSupportOptions) {
    const event: PreSupportSelectionEvent = {
      type: SystemEvent.PRE_SUPPORT_SELECTION,
      message: this.message,
      payload: { selected },
    };

    this.$emit('send:event', event);
  }
}
</script>

<style scoped lang="scss">
@import './ActionButtonCommon.scss';
</style>
